import ObjectModelBuilderModel from "./tracked/objectModelBuilderModel";
import IRepo from "../interfaces/repo";
import Repo from "../state/modules/repo";
import Guid from "../helpers/guid";
import ObjectModel from "./objectModel";
import { RelationType } from "./relationType";
import { ConditionalFieldDefinition } from "./conditionalRules/conditionalFieldDefinition";
import ObjectModelConditionalFields from "~/models/objectModels/objectModelConditionalFields";
import ConditionalRuleSetFactory from "~/models/conditionalRules/conditionalRuleSetFactory";
import { Hash } from "~/interfaces/hashInterfaces";
import ObjectModelConditionalRuleSet from "~/models/objectModels/objectModelConditionalRuleSet";
import IConditionalRuleContainer from "~/models/conditionalRules/conditionalRuleContainer";
import { ObjectHelper } from "~/helpers/objectHelper";
import ObjectModelProperty from "~/models/objectModelProperties/objectModelProperty";
import GloballySelected from "../../formability/object_model_builder/store/modules/selected";
import Validatable from "~/mixins/validatable";
import { ObjectModelPropertyRootType } from "~/enums/objectModelPropertyType";
import DashboardConditionalLinkedDetailViewValidation from "./navigableValidations/dashboardConditionalLinkedDetailViewValidation";

export default class DashboardConditionalLinkedDetailView extends Validatable(ObjectModelBuilderModel) implements IConditionalRuleContainer {
  conditional_linked_detail_view_id: string;
  dashboard_conditional_linked_detail_view_conditional_rule_sets: Hash<ObjectModelConditionalRuleSet> = {};

  // Methods

  addToRepo(): void {
    DashboardConditionalLinkedDetailView.repo.add(this);
  }

  select(): void {
    GloballySelected.dashboardLinkedDetailView.set(this);
  }

  // Validation

  _validation: DashboardConditionalLinkedDetailViewValidation = new DashboardConditionalLinkedDetailViewValidation(this);

  getDisplayName(propName: string, value?): string {
    switch (propName) {
      case "conditional_linked_detail_view_id":
        return "You must choose a detail view for the dashboard"
      case "dashboard_conditional_linked_detail_view_conditional_rule_sets":
        return "You must fully configure the conditional detail view rules"
      default:
        return propName
    }
  }

  // Embedded Models


  get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
    const models = {};
    for (const definition of ObjectModelConditionalFields.DASHBOARD_CONDITIONAL_LINKED_DETAIL_VIEW_FIELDS) {
      models[`${definition.fieldName}_conditional_rule_sets`] = { type: ObjectModelConditionalRuleSet, relationType: RelationType.dictionary };
      if (definition.defaultConditionalValue instanceof Function) {
        models[definition.fieldName] = { type: Object, relationType: RelationType.singleObject };
      }
    }
    return models;
  }

  createEmbeddedObject = {};

  // Conditional Rule Sets

  getConditionalRuleSets(fieldName: string): Hash<ObjectModelConditionalRuleSet> {
    return this[`${fieldName}_conditional_rule_sets`];
  }

  getSortedConditionalRuleSets(fieldName: string): ObjectModelConditionalRuleSet[] {
    const ruleSets = this.getConditionalRuleSets(fieldName);
    return ObjectHelper.toArray(ruleSets).sort((x, y) => x.sort_order < y.sort_order ? -1 : 1);
  }

  createNewRuleSet(fieldName: string, definition: ConditionalFieldDefinition): ObjectModelConditionalRuleSet {
    return new ObjectModelConditionalRuleSet(fieldName, definition);
  }

  getReferencedControl(id: string): ObjectModelProperty {
    return ObjectModelProperty.repo.find(id);
  }

  getReferencableControls(): ObjectModelProperty[] {
    return this.rootModel.objectModelPropertiesArray.filter(objectModelProperty => objectModelProperty.property_type === ObjectModelPropertyRootType.PickList)
  }

  // Class Configurations

  constructor() {
    super();
    this.defineProperty('client_id', Guid.create());
    this.defineProperty('conditional_linked_detail_view_id', null)

    for (const definition of ObjectModelConditionalFields.DASHBOARD_CONDITIONAL_LINKED_DETAIL_VIEW_FIELDS) {
      const conditionalFieldName = `${definition.fieldName}_conditional_rule_sets`;
      this.except.push(conditionalFieldName);
      this[conditionalFieldName] = {};
      this.createEmbeddedObject[conditionalFieldName] = (parent, json) => {
        return ConditionalRuleSetFactory.createForContainer(this, definition, {}, true, false);
      };
      if (definition.defaultConditionalValue instanceof Function) {
        this.except.push(definition.fieldName);
        this.createEmbeddedObject[definition.fieldName] = definition.defaultConditionalValue;
      }
    }
  }

  initialize(root: ObjectModel, parent: ObjectModel, type: number = 0, json: object = {}): this {
    this.rootModel = root;
    this.parent = parent;
    this.loadFromJson(json);

    const ruleSet = ConditionalRuleSetFactory.createForContainer(
      this,
      ObjectModelConditionalFields.DASHBOARD_CONDITIONAL_LINKED_DETAIL_VIEW,
      {},
      false,
      true
    );
    ruleSet.attachToParent(this);
    return this;
  }

  static repo: IRepo<DashboardConditionalLinkedDetailView> = new Repo<DashboardConditionalLinkedDetailView>('dashboardConditionalLinkedDetailViewss', DashboardConditionalLinkedDetailView);

  static get rootName(): string {
    return 'dashboard_conditional_linked_detail_views';
  }

  get rootName(): string {
    return 'dashboard_conditional_linked_detail_views';
  }

}